__webpack_require__.p = "/CineCurse/";